import { Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonAutocomplete from "../../components/CommonAutocomplete";
import useInputObject from "../../hooks/useInputObject";
import { convertToHiragana } from "../../utils/convertToHalfWidthKana";
import { isNullEmpty } from "../../utils/validation";
import { formatCurrency } from "../../utils/utils";
import {stripTrailingZeros} from "../../utils/decimal";

const HeaderTextField = (props) => {
  return (
    <TextField
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        paddingInline: 0,
      }}
      {...props}
    >
      {props.children}
    </TextField>
  );
};

const DetailItem = (props) => {
  const {
    index,
    updateDetail,
    detailsAPI,
    ranks,
    productClasses,
    packings,
    productsAC,
    productSelectable,
    origins,
    focusNavigation,
  } = props;

  const data = useInputObject(props.detail);

  const [rank, setRank] = useState({});
  const [productClass, setProductClass] = useState({});
  const [packing, setPacking] = useState({});
  const [product, setProduct] = useState({});
  const [origin, setOrigin] = useState({});
  useEffect(() => {
    if (detailsAPI.Value[index]) data.setValue(detailsAPI.Value[index]);
    setRank(ranks.find((x) => x.rankId === detailsAPI.Value[index]?.rankId));
    setProductClass(
      productClasses.find(
        (x) => x.productClassId === detailsAPI.Value[index]?.productClassId
      )
    );
    setPacking(
      packings.find((x) => x.packingId === detailsAPI.Value[index]?.packingId)
    );
    setProduct(
      productsAC.find((x) => x.productId === detailsAPI.Value[index]?.productId)
    );
    setOrigin(
      origins.find((x) => x.originId === detailsAPI.Value[index]?.originId)
    );
    setTimeout(
      () => data.update("productName", detailsAPI.Value[index]?.productName),
      1000
    );
  }, [detailsAPI.Value]);

  useEffect(() => {
    data.update("rankId", rank?.rankId || "");
  }, [rank]);
  useEffect(() => {
    data.update("productClassId", productClass?.productClassId || "");
  }, [productClass]);
  useEffect(() => {
    data.update("packingId", packing?.packingId || "");
  }, [packing]);
  useEffect(() => {
    data.update("originId", origin?.originId || "");
  }, [origin]);
  useEffect(() => {
    data.update("productId", product?.productId || "");
    if (isNullEmpty(data.Value.productName)) {
      data.update("productName", product?.chainStoreProductName || "");
    }
  }, [product]);

  function handleBlur() {
    updateDetail(index, data.Value);
  }

  function handleFocus(e) {
    e.target.select();
  }
  return (
    <Grid
      container
      my={1}
      onBlur={handleBlur}
      onFocus={handleFocus}
      display={"flex"}
      justifyContent="start"
    >
      <Grid item xs={0.9}>
        <CommonAutocomplete
          // label="品名"
          value={product || null}
          onSelect={(e, newValue) => {
            setProduct(newValue);
            focusNavigation(document.activeElement, false);
          }}
          id={`productItem-${index}-0`}
          data={productSelectable}
          filterOptions={(options, { inputValue }) => {
            let convertHira = convertToHiragana(inputValue);
            return options.filter(
              (x) =>
                x.productId.toString().startsWith(convertHira) ||
                x.chainStoreProductName?.includes(convertHira)
            );
          }}
          optionLabel={(option) => (option ? option.productId?.toString() : "")}
          renderOption={(props, option) => (
            <li {...props}>
              {option.productId} - {option.chainStoreProductName}
            </li>
          )}
          componentsProps={{
            paper: {
              sx: {
                width: 300,
              },
            },
          }}
          width="95%"
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          sx={{ width: "95%" }}
          value={data.Value.productName || ""}
          onChange={(e) => data.update("productName", e.target.value)}
          id={`productItem-${index}-1`}
        ></TextField>
      </Grid>
      <Grid item xs={1.5}>
        <CommonAutocomplete
          value={origin || null}
          onSelect={(e, newValue) => {
            setOrigin(newValue);
            focusNavigation(document.activeElement, false);
          }}
          id={`productItem-${index}-2`}
          data={origins}
          filterOptions={(options, { inputValue }) => {
            inputValue = inputValue.trim();
            return options.filter((x) => {
              return x.originId.toString().startsWith(inputValue);
              // x.originName.includes(inputValue)
            });
          }}
          optionLabel={(option) =>
            option ? option.originId + " - " + option.originName : ""
          }
          width={"95%"}
        />
      </Grid>
      {/* 等級 */}
      <Grid item xs={1.2}>
        <CommonAutocomplete
          value={rank || null}
          onSelect={(e, newValue) => {
            setRank(newValue);
            focusNavigation(document.activeElement, false);
          }}
          id={`productItem-${index}-3`}
          data={ranks}
          filterOptions={(options, { inputValue }) => {
            inputValue = inputValue.trim();
            return options.filter((x) => {
              return x.rankId.toString().startsWith(inputValue);
              // x.rankName.includes(inputValue)
            });
          }}
          optionLabel={(option) =>
            option ? option.rankId + " - " + option.rankName : ""
          }
          width="95%"
        />
      </Grid>
      {/* 階級 */}
      <Grid item xs={1.2}>
        <CommonAutocomplete
          // label="階級"
          value={productClass || null}
          onSelect={(e, newValue) => {
            setProductClass(newValue);
            focusNavigation(document.activeElement, false);
          }}
          id={`productItem-${index}-4`}
          data={productClasses}
          filterOptions={(options, { inputValue }) => {
            inputValue = inputValue.trim();
            return options.filter((x) => {
              return x.productClassId.toString().startsWith(inputValue);
              // x.productClassName.includes(inputValue)
            });
          }}
          optionLabel={(option) =>
            option
              ? option.productClassId + " - " + option.productClassName
              : ""
          }
          width="95%"
        />
      </Grid>
      {/* 荷姿 */}
      <Grid item xs={1.2}>
        <CommonAutocomplete
          // label="荷姿"
          value={packing || null}
          onSelect={(e, newValue) => {
            setPacking(newValue);
            focusNavigation(document.activeElement, false);
          }}
          id={`productItem-${index}-5`}
          data={packings}
          filterOptions={(options, { inputValue }) => {
            inputValue = inputValue.trim();
            return options.filter((x) => {
              return x.packingId.toString().startsWith(inputValue);
              // x.packingName.includes(inputValue)
            });
          }}
          optionLabel={(option) =>
            option ? option.packingId + " - " + option.packingName : ""
          }
          width="95%"
        />
      </Grid>
      {/* 入数 */}
      <Grid item xs={1}>
        <HeaderTextField
          sx={{ width: "95%" }}
          value={data.Value.unitQuantity || ""}
          type="number"
          onChange={(e) => data.update("unitQuantity", e.target.value)}
          id={`productItem-${index}-6`}
        ></HeaderTextField>
      </Grid>
      {/* 単価 */}
      <Grid item xs={1}>
        <HeaderTextField
          sx={{ width: "95%" }}
          value={data.Value.unitPrice || ""}
          type="number"
          onChange={(e) => data.update("unitPrice", e.target.value)}
          id={`productItem-${index}-7`}
        ></HeaderTextField>
      </Grid>
      {/* 数量 */}
      <Grid item xs={1}>
        <HeaderTextField
          sx={{ width: "95%" }}
          value={stripTrailingZeros(data.Value.quantity) || ""}
          onChange={(e) => data.update("quantity", stripTrailingZeros(e.target.value))}
          type="number"
          id={`productItem-${index}-8`}
        ></HeaderTextField>
      </Grid>
      {/* 金額 */}
      <Grid item xs={1}>
        <HeaderTextField
          sx={{ width: "95%" }}
          value={
            (data.Value.unitQuantity || 1) *
              data.Value.quantity *
              data.Value.unitPrice ===
            0
              ? ""
              : formatCurrency(
                  (data.Value.unitQuantity || 1) *
                    data.Value.quantity *
                    data.Value.unitPrice
                ) || ""
          }
          disabled
          // onChange={(e) => data.update("price", e.target.value)}
          id={`productItem-${index}-9`}
        />
      </Grid>
    </Grid>
  );
};

export default React.memo(DetailItem);
